import { EntityInput, isURLAbsolute, LinkProps } from "helpers/url";

export function productAnalogsHref(
  entity: EntityInput,
  origin?: string
): LinkProps["href"] {
  if (isURLAbsolute(entity.url)) {
    return entity.url;
  }

  /* Copy rules from product when analogs will be implemented */

  return productAnalogsAs(entity, origin);
}

export function productAnalogsAs(
  entity: EntityInput,
  origin?: string
): LinkProps["as"] {
  const originSegment = origin || "";
  if (entity.url) {
    return `${originSegment}${entity.url.replace(".html", "/analogi/")}`;
  }

  return `${originSegment}/p_${encodeURIComponent(entity.alias).replace(
    ".html",
    ""
  )}/analogi/`;
}
